import useRedmineUrl from 'infrastructure/integrations/redmine/useRedmineUrl';
import { LinkField } from 'framework/ui/field';

type RedmineIssueListFieldProps = {
  id: number;
};

const RedmineIssueListField = ({ id, ...props }: RedmineIssueListFieldProps) => {
  const { getIssueUrl } = useRedmineUrl();
  const value = id && getIssueUrl(id);

  return <LinkField {...props} linkText={id} value={value as string} isInternal={false} />;
};

export default RedmineIssueListField;
